import { createFrontendModule } from "@backstage/frontend-plugin-api";
import { entityPresentationApi } from "../../extensions";

export const catalogEntityPresentationModule = createFrontendModule({
  pluginId: 'catalog',
  extensions: [
    entityPresentationApi,
  ],
});
